import { useCallback, useEffect, useMemo, useState } from "react"
import { determineRSEndpoint } from "./generateRSToken";
import { Auth } from "aws-amplify";
import axios from "axios";

interface RsMarket {
    market: string;
    retailNetworks: string[];
    products: MarketProduct[];
}

interface MarketProduct {
    brand: string;
    flavour: string;
    productId: string;
    salesUnit: string;
    packageSize: string;
    packageType: string;
    sku: string;
}

export const useGetSkuPerMarket = (country?: string) => {
    const url = `${determineRSEndpoint()}/api/receipt-scanner/v1/admin/markets` as const;
    const [markets, setMarkets] = useState<RsMarket[]>([]);

    const fetchMarketSku =  useCallback(async () => {
        try {
            const session = await Auth.currentSession();
            const idToken = session.getIdToken().getJwtToken();
            if (!idToken) return;

            const res = await axios.get<{ markets: RsMarket[] }>(url, {
                headers: { Authorization: `Bearer ${idToken}` }
            })
            setMarkets(res?.data?.markets ?? []);

        } catch (err) {
            console.error('Error while fetching markets with sku', err);
        }

    }, [url, setMarkets])

    useEffect(() => {
        if (!markets.length) {
            fetchMarketSku();
        };
    }, [fetchMarketSku, markets])

    const getMarket = useCallback(
        () => {
            const market = country?.trim();
            return market || undefined;
        },
        [country])

    const skusForMarket = useMemo(() => {
        const market = getMarket();
        const marketSkus = market ?
            markets?.find(
                (marketObj) => market.toLowerCase() === marketObj.market.toLowerCase()
            )?.products?.map((product) => product.sku)
            : []
        return Array.from(new Set(marketSkus));
    }, [getMarket, markets])

    return (
        {
            skusForMarket
        }
    )
}
